<div class="marker-wrapper" [ngClass]="{ 'is-for-sale': data()?.isForSale, 'is-judicial-transfer': data()?.isJudicialTransfer }">
    <div class="icon" [class]="'property-' + data().estateTypeCssString"></div>
    <div class="price-tag">
        @if(price()){
        <b>{{ price() / 1000000 | number : "1.1-1" | dash }}</b> mill } @if(validArea()) { <b>{{ validArea() }}</b
        >m² }
    </div>
</div>
